export default "__VITE_ASSET__ymLpk_FP__"